<template>
  <div v-if="kpis.length" class="rd-kpis">
    <div v-for="kpi in kpis" :key="kpi.key" class="ui-stat" :class="kpi.tone ? `rd-kpi--${kpi.tone}` : ''">
      <span class="ui-stat__label">{{ kpi.label }}</span>
      <span class="ui-stat__value">
        {{ kpi.value }}<small v-if="kpi.of != null"> / {{ kpi.of }}</small>
      </span>
      <span
        v-if="kpi.percent != null"
        class="ui-stat__bar"
        role="progressbar"
        :aria-valuenow="kpi.value"
        aria-valuemin="0"
        :aria-valuemax="kpi.of"
      >
        <i :style="{ width: `${kpi.percent}%` }"></i>
      </span>
    </div>
  </div>
</template>

<script>
/**
 * Brojke u zaglavlju izveštaja: [{ key, label, value, of?, percent?, tone? }].
 * tone: "inverse" (tamna), "accent" (u boji akcenta); of/percent crtaju napredak (npr. preuzeto / poručeno).
 */
export default {
  name: "ReportKpis",
  props: {
    kpis: { type: Array, default: () => [] },
  },
};
</script>
